// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-icon {\n  position: absolute;\n  right: 0;\n  height: 100%;\n  z-index: 100;\n}\n\n::ng-deep .was-validated .ng-invalid + .search-icon {\n  display: none;\n}\n\n::placeholder {\n  color: lightgray;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
